import React, { useState } from "react";

export default function TrackingApp() {
  const [trackingId, setTrackingId] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const API =
    "https://opensheet.elk.sh/1tDFROBZ10ovYaWU8B2Hu7XE_9I5Gv-ehAb0DDiWsX6Q/Sheet1";

  // 🔥 SMART MATCH (space + underscore ignore)
  const getValue = (obj, key) => {
    const normalize = (str) =>
      str.replace(/\s|_/g, "").toLowerCase();

    const foundKey = Object.keys(obj).find(
      (k) => normalize(k) === normalize(key)
    );

    return foundKey ? obj[foundKey] : "";
  };

  const trackOrder = async () => {
    if (!trackingId) return alert("Enter LR Number");

    setLoading(true);

    try {
      const res = await fetch(API);
      const all = await res.json();

      const filtered = all.filter((item) =>
        getValue(item, "LR_No")
          ?.toLowerCase()
          .includes(trackingId.toLowerCase())
      );

      if (filtered.length === 0) {
        alert("❌ Not Found");
        setLoading(false);
        return;
      }

      const latest = filtered[filtered.length - 1];

      setData({
        lr: getValue(latest, "LR_No"),
        truck: getValue(latest, "Truck_No"),
        weight: getValue(latest, "Weight"),
        date: getValue(latest, "Date"),
        from: getValue(latest, "From"),
        to: getValue(latest, "To"),

        // 🔥 FIXED INVOICE (multi fallback)
        invoice:
          getValue(latest, "Invoice_No") ||
          getValue(latest, "Invoice No") ||
          getValue(latest, "Invice_No") ||
          "N/A",

        consignor: getValue(latest, "Consignor"),

        // ✅ Status SAME as sheet (no change)
        status: getValue(latest, "Status"),

        // 🔥 DAY-WISE LOCATION
        days: [
          getValue(latest, "1_day"),
          getValue(latest, "2_day"),
          getValue(latest, "3_day"),
          getValue(latest, "4_day"),
          getValue(latest, "5_day"),
        ],

        history: filtered,
      });
    } catch {
      alert("Error ❌");
    }

    setLoading(false);
  };

  return (
    <>
      <style>{`
        body {
          margin: 0;
          font-family: 'Segoe UI', sans-serif;
          background: linear-gradient(135deg,#eef2ff,#f8fafc);
        }

        .container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .card {
          width: 100%;
          max-width: 550px;
          background: white;
          border-radius: 20px;
          padding: 25px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.1);
        }

        .title {
          text-align: center;
          font-size: 22px;
          margin-bottom: 20px;
        }

        .input {
          width: 100%;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid #ddd;
          margin-bottom: 10px;
        }

        .btn {
          width: 100%;
          padding: 12px;
          background: linear-gradient(90deg,#4f46e5,#6366f1);
          color: white;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          font-weight: bold;
        }

        .grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-top: 15px;
        }

        .box {
          background: #f9fafb;
          padding: 10px;
          border-radius: 8px;
        }

        .label {
          font-size: 11px;
          color: gray;
        }

        .value {
          font-weight: bold;
        }

        .status {
          margin-top: 15px;
          padding: 15px;
          background: #ecfdf5;
          border-left: 5px solid green;
          border-radius: 10px;
        }

        .timeline {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
        }

        .dayBox {
          width: 70px;
          text-align: center;
        }

        .circle {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin: auto;
          margin-bottom: 5px;
        }

        .done { background: green; }
        .pending { background: #ccc; }

        .dayTitle {
          font-size: 12px;
          font-weight: bold;
        }

        .dayLocation {
          font-size: 11px;
          color: #555;
        }

        .history {
          margin-top: 20px;
        }

        .historyItem {
          background: #f3f4f6;
          padding: 10px;
          border-radius: 8px;
          margin-bottom: 10px;
        }
      `}</style>

      <div className="container">
        <div className="card">

          <h2 className="title">🚛 Track Order</h2>

          <input
            className="input"
            placeholder="Enter LR Number"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
          />

          <button className="btn" onClick={trackOrder}>
            {loading ? "Tracking..." : "Track Now"}
          </button>

          {data && (
            <>
              <div className="grid">
                <div className="box"><p className="label">LR No</p><p className="value">{data.lr}</p></div>
                <div className="box"><p className="label">Truck</p><p className="value">{data.truck}</p></div>
                <div className="box"><p className="label">Weight</p><p className="value">{data.weight}</p></div>
                <div className="box"><p className="label">Date</p><p className="value">{data.date}</p></div>
                <div className="box"><p className="label">From</p><p className="value">{data.from}</p></div>
                <div className="box"><p className="label">To</p><p className="value">{data.to}</p></div>
                <div className="box"><p className="label">Invoice No</p><p className="value">{data.invoice}</p></div>
                <div className="box"><p className="label">Consignor</p><p className="value">{data.consignor}</p></div>
              </div>

              {/* ✅ STATUS SAME AS SHEET */}
              <div className="status">
                <b>Status:</b> {data.status}
              </div>

              {/* 🔥 DAY-WISE LOCATION */}
              <div className="timeline">
                {data.days.map((d, i) => {
                  const done = d && d.trim() !== "";

                  return (
                    <div key={i} className="dayBox">
                      <div className={`circle ${done ? "done" : "pending"}`} />
                      <p className="dayTitle">Day {i + 1}</p>
                      <p className="dayLocation">
                        {done ? d : "Not Reached"}
                      </p>
                    </div>
                  );
                })}
              </div>

              {/* 📜 HISTORY */}
              {/* <div className="history">
                <h4>Shipment History</h4>
                {data.history.slice().reverse().map((item, i) => (
                  <div key={i} className="historyItem">
                    <b>{getValue(item, "Status")}</b>
                    <p>📍 {getValue(item, "Location")}</p>
                    <small>{getValue(item, "Date")}</small>
                  </div>
                ))}
              </div> */}
            </>
          )}

        </div>
      </div>
    </>
  );
}